import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const mobileCategoryThumbs: Record<string, string> = {
  'cat-shoes-01': 'https://readdy.ai/api/search-image?query=Minimalist%20product%20thumbnail%20of%20shoes%20on%20a%20clean%20studio%20background%2C%20small%20square%20product%20photography&width=64&height=64&seq=mob-shoes&orientation=squarish',
  'cat-hoodies-02': 'https://readdy.ai/api/search-image?query=Minimalist%20product%20thumbnail%20of%20hoodie%20on%20a%20clean%20studio%20background%2C%20small%20square%20product%20photography&width=64&height=64&seq=mob-hoodies&orientation=squarish',
  'cat-tshirts-03': 'https://readdy.ai/api/search-image?query=Minimalist%20product%20thumbnail%20of%20tshirt%20on%20a%20clean%20studio%20background%2C%20small%20square%20product%20photography&width=64&height=64&seq=mob-tshirts&orientation=squarish',
  'cat-jackets-04': 'https://readdy.ai/api/search-image?query=Minimalist%20product%20thumbnail%20of%20jacket%20on%20a%20clean%20studio%20background%2C%20small%20square%20product%20photography&width=64&height=64&seq=mob-jackets&orientation=squarish',
  'cat-pants-05': 'https://readdy.ai/api/search-image?query=Minimalist%20product%20thumbnail%20of%20pants%20on%20a%20clean%20studio%20background%2C%20small%20square%20product%20photography&width=64&height=64&seq=mob-pants&orientation=squarish',
  'cat-headwear-06': 'https://readdy.ai/api/search-image?query=Minimalist%20product%20thumbnail%20of%20baseball%20cap%20on%20a%20clean%20studio%20background%2C%20small%20square%20product%20photography&width=64&height=64&seq=mob-headwear&orientation=squarish',
  'cat-sets-07': 'https://readdy.ai/api/search-image?query=Minimalist%20product%20thumbnail%20of%20clothing%20set%20on%20a%20clean%20studio%20background%2C%20small%20square%20product%20photography&width=64&height=64&seq=mob-sets&orientation=squarish',
  'cat-underwear-08': 'https://readdy.ai/api/search-image?query=Minimalist%20product%20thumbnail%20of%20underwear%20on%20a%20clean%20studio%20background%2C%20small%20square%20product%20photography&width=64&height=64&seq=mob-underwear&orientation=squarish',
  'cat-jersey-09': 'https://readdy.ai/api/search-image?query=Minimalist%20product%20thumbnail%20of%20sports%20jersey%20on%20a%20clean%20studio%20background%2C%20small%20square%20product%20photography&width=64&height=64&seq=mob-jersey&orientation=squarish',
  'cat-accessories-10': 'https://readdy.ai/api/search-image?query=Minimalist%20product%20thumbnail%20of%20fashion%20accessories%20on%20a%20clean%20studio%20background%2C%20small%20square%20product%20photography&width=64&height=64&seq=mob-accessories&orientation=squarish',
  'cat-bags-11': 'https://readdy.ai/api/search-image?query=Minimalist%20product%20thumbnail%20of%20backpack%20bag%20on%20a%20clean%20studio%20background%2C%20small%20square%20product%20photography&width=64&height=64&seq=mob-bags&orientation=squarish',
  'cat-belts-12': 'https://readdy.ai/api/search-image?query=Minimalist%20product%20thumbnail%20of%20leather%20belt%20on%20a%20clean%20studio%20background%2C%20small%20square%20product%20photography&width=64&height=64&seq=mob-belts&orientation=squarish',
  'cat-perfumes-13': 'https://readdy.ai/api/search-image?query=Minimalist%20product%20thumbnail%20of%20perfume%20bottle%20on%20a%20clean%20studio%20background%2C%20small%20square%20product%20photography&width=64&height=64&seq=mob-perfumes&orientation=squarish',
  'cat-other-14': 'https://readdy.ai/api/search-image?query=Minimalist%20product%20thumbnail%20of%20lifestyle%20accessories%20on%20a%20clean%20studio%20background%2C%20small%20square%20product%20photography&width=64&height=64&seq=mob-other&orientation=squarish',
};

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [mobileOpen]);

  const closeMobile = () => setMobileOpen(false);

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? 'bg-background-50/95 backdrop-blur-sm border-b border-background-200/70'
            : 'bg-background-50 md:bg-transparent'
        }`}
      >
        <div className="w-full px-4 md:px-6">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-2 group" onClick={closeMobile}>
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-file-list-3-line text-xl text-primary-500"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-foreground-900 whitespace-nowrap">
                Sugargoo<span className="text-primary-500">Sheet</span>
              </span>
            </Link>

            <div className="hidden md:flex items-center gap-6">
              <Link
                to="/"
                className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-1.5"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-home-4-line text-sm"></i>
                </div>
                Home
              </Link>
              <Link
                to="/blog"
                className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-1.5"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-book-open-line text-sm"></i>
                </div>
                Shopping Guide
              </Link>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                Spreadsheet
              </a>
              <a
                href="#categories"
                className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                Categories
              </a>
              <Link
                to="/blog"
                className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                Guides
              </Link>
              <a
                href="#faq"
                className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                FAQ
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                Buy It Now
              </a>
            </div>

            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer relative z-50"
              aria-label="Menu"
            >
              <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl text-foreground-900`}></i>
            </button>
          </div>
        </div>
      </nav>

      {mobileOpen && (
        <div className="fixed inset-0 z-40 md:hidden">
          <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={closeMobile}></div>
          <div className="absolute top-0 right-0 w-80 max-w-[85vw] h-full bg-background-50 overflow-y-auto pt-20 pb-8 px-5">
            <div className="flex flex-col gap-1 mb-6">
              <Link
                to="/"
                onClick={closeMobile}
                className="flex items-center gap-3 px-3 py-3 rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
              >
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-50 flex-shrink-0">
                  <i className="ri-home-4-line text-primary-500 text-lg"></i>
                </div>
                <div className="flex flex-col">
                  <span className="text-sm font-medium text-foreground-900">Home</span>
                  <span className="text-xs text-foreground-500">Back to homepage</span>
                </div>
              </Link>

              <Link
                to="/blog"
                onClick={closeMobile}
                className="flex items-center gap-3 px-3 py-3 rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
              >
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-50 flex-shrink-0">
                  <i className="ri-book-open-line text-accent-500 text-lg"></i>
                </div>
                <div className="flex flex-col">
                  <span className="text-sm font-medium text-foreground-900">Shopping Guide</span>
                  <span className="text-xs text-foreground-500">SEO articles & buying tips</span>
                </div>
              </Link>

              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                onClick={closeMobile}
                className="flex items-center gap-3 px-3 py-3 rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
              >
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-50 flex-shrink-0">
                  <i className="ri-external-link-line text-secondary-500 text-lg"></i>
                </div>
                <div className="flex flex-col">
                  <span className="text-sm font-medium text-foreground-900">Spreadsheet</span>
                  <span className="text-xs text-foreground-500">Main platform</span>
                </div>
              </a>

              <a
                href="#categories"
                onClick={closeMobile}
                className="flex items-center gap-3 px-3 py-3 rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
              >
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 flex-shrink-0">
                  <i className="ri-grid-line text-foreground-600 text-lg"></i>
                </div>
                <div className="flex flex-col">
                  <span className="text-sm font-medium text-foreground-900">Categories</span>
                  <span className="text-xs text-foreground-500">Browse products</span>
                </div>
              </a>

              <a
                href="#faq"
                onClick={closeMobile}
                className="flex items-center gap-3 px-3 py-3 rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
              >
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 flex-shrink-0">
                  <i className="ri-question-line text-foreground-600 text-lg"></i>
                </div>
                <div className="flex flex-col">
                  <span className="text-sm font-medium text-foreground-900">FAQ</span>
                  <span className="text-xs text-foreground-500">Common questions</span>
                </div>
              </a>
            </div>

            <div className="border-t border-background-200/70 pt-5 mb-1">
              <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-3 px-3">
                Product Categories
              </h4>
              <div className="flex flex-col gap-0.5">
                {categories.map((cat) => (
                  <a
                    key={cat.slug}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    onClick={closeMobile}
                    className="flex items-center gap-3 px-3 py-2.5 rounded-lg hover:bg-background-100 transition-colors cursor-pointer group"
                  >
                    <div className="w-8 h-8 rounded-md overflow-hidden flex-shrink-0">
                      <img
                        src={mobileCategoryThumbs[cat.imageSeq] || mobileCategoryThumbs['cat-other-14']}
                        alt={cat.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <span className="text-sm text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                      {cat.name}
                    </span>
                  </a>
                ))}
              </div>
            </div>

            <div className="mt-5 pt-5 border-t border-background-200/70">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                onClick={closeMobile}
                className="w-full flex items-center justify-center gap-2 px-4 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                Buy It Now
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-shopping-bag-line text-sm"></i>
                </div>
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
}